import { EducationManager } from '@/plugins/api'
import { upsertMany } from '@/helpers'

export default {
  namespaced: true,
  state: {
    educationManagers: [],
    isLoading: false
  },
  actions: {
    async fetchEducationManagers({ commit }, options) {
      const res = await EducationManager.fetch(options)
      commit('setEducationManagers', res)
    },
    async fetchEducationManager({ commit, state }, { id, options }) {
      const res = await EducationManager.fetchOne(id, options)
      commit('setEducationManagers', upsertMany(state.educationManagers, res))
    },
    async updateEducationManager({ commit, state }, { id, params, options }) {
      const res = await EducationManager.update(id, params, options)
      commit('setEducationManagers', upsertMany(state.educationManagers, res))
    },
    async createEducationManager({ commit, state }, { params, options }) {
      const res = await EducationManager.create(params, options)
      commit('setEducationManagers', upsertMany(state.educationManagers, res))
    },
    async removeEducationManager({ commit, state }, { id, options }) {
      await EducationManager.remove(id, options)
      commit(
        'setEducationManagers',
        state.educationManagers.filter(i => i.id !== id)
      )
    },
    async swapEducationManager({ commit, state }, { id, params, options }) {
      await EducationManager.swap(id, params, options)
      commit(
        'setEducationManagers',
        state.educationManagers.filter(i => i.id !== id)
      )
    }
  },
  mutations: {
    setEducationManagers(state, v) {
      state.educationManagers = v
    }
  }
}
